import { createContext, useContext, useReducer } from "react";
import PropTypes from "prop-types";

export const DrawDetailsContext = createContext();
DrawDetailsContext.displayName = "drawDetails";

export const useDrawDetails = () => useContext(DrawDetailsContext);

export const DrawDetailsProvider = ({ children, initialState, reducer }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <DrawDetailsContext.Provider value={[state, dispatch]}>
      {children}
    </DrawDetailsContext.Provider>
  );
};

DrawDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    hasError: PropTypes.bool.isRequired,
    content: PropTypes.object.isRequired,
    drawDetails: PropTypes.object.isRequired,
    variants: PropTypes.array.isRequired,
  }),
  reducer: PropTypes.func.isRequired,
};
